import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Copy, Megaphone } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function Announcement() {
  const { id } = useParams();
  const [ann, setAnn] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/announcements/${id}`).then(({ data }) => setAnn(data)).catch(() => setMissing(true));
  }, [id]);

  const copy = () => { navigator.clipboard.writeText(ann.invite_link); toast.success("Invite link copied"); };

  if (missing) return <p className="text-ink-500" data-testid="announcement-missing">This announcement isn't available.</p>;
  if (!ann) return null;

  return (
    <div className="space-y-5 max-w-2xl" data-testid="announcement-page">
      <div>
        <div className="label-overline flex items-center gap-1.5"><Megaphone size={12} /> Announcement</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-1" data-testid="announcement-title">{ann.title}</h1>
        {ann.sent_at && <div className="text-xs text-ink-500 mt-1">{new Date(ann.sent_at).toLocaleDateString()}</div>}
      </div>
      {ann.include_invite && ann.body_before != null ? (
        <>
          <Body text={ann.body_before} testid="announcement-body" />
          <InviteBox link={ann.invite_link} onCopy={copy} />
          <Body text={ann.body_after} testid="announcement-body-after" />
        </>
      ) : (
        <>
          <Body text={ann.body} testid="announcement-body" />
          {ann.include_invite && <InviteBox link={ann.invite_link} onCopy={copy} />}
        </>
      )}
    </div>
  );
}

function Body({ text, testid }) {
  if (!text) return null;
  return <div className="text-ink-700 whitespace-pre-line leading-relaxed" data-testid={testid}>{text}</div>;
}

function InviteBox({ link, onCopy }) {
  return (
    <section className="card-base p-5 space-y-3" data-testid="announcement-invite-box">
      <div className="label-overline">Your personal invite link</div>
      <div className="text-sm bg-ivory-100 rounded-xl p-2.5 break-all" data-testid="announcement-invite-link">{link}</div>
      <p className="text-xs text-ink-500">Copy it into a message or email to a musician you know.</p>
      <div className="flex flex-wrap gap-2">
        <button className="btn-primary" onClick={onCopy} data-testid="announcement-copy-invite"><Copy size={16} /> Copy invite link</button>
        <Link to="/profile" className="btn-secondary" data-testid="announcement-see-invites">See your invites</Link>
      </div>
    </section>
  );
}
